// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"e91c4cac","415":"4d6acbeb","787":"1ed0c42c"}[chunkId] + ".chunk.js";
};